var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEditFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 12.0625H1.25C0.973437 12.0625 0.75 12.2859 0.75 12.5625V13.125C0.75 13.1938 0.80625 13.25 0.875 13.25H13.125C13.1938 13.25 13.25 13.1938 13.25 13.125V12.5625C13.25 12.2859 13.0266 12.0625 12.75 12.0625ZM3.02656 10.75C3.05781 10.75 3.08906 10.7469 3.12031 10.7422L5.74844 10.2812C5.77969 10.275 5.80938 10.2609 5.83125 10.2375L12.4547 3.61406C12.4692 3.59961 12.4807 3.58244 12.4885 3.56354C12.4963 3.54463 12.5004 3.52437 12.5004 3.50391C12.5004 3.48344 12.4963 3.46318 12.4885 3.44428C12.4807 3.42538 12.4692 3.40821 12.4547 3.39375L9.85781 0.795313C9.82812 0.765625 9.78906 0.75 9.74687 0.75C9.70469 0.75 9.66563 0.765625 9.63594 0.795313L3.0125 7.41875C2.98906 7.44219 2.975 7.47031 2.96875 7.50156L2.50781 10.1297C2.49261 10.2134 2.49804 10.2995 2.52364 10.3807C2.54923 10.4618 2.59421 10.5355 2.65469 10.5953C2.75781 10.6953 2.8875 10.75 3.02656 10.75Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditFilled);
export default __webpack_public_path__ + "static/media/edit-filled.47f9d297b5a9a6b83cbb5cd522d1d59e.svg";
export { ForwardRef as ReactComponent };